import * as React from 'react';
import "../Login/Login.css";

import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import { EmailInput, FormInput } from "../../Utils/form-components"
import { emailValidator, passwordValidator, passwordValidationMessage } from "../../Utils/validators"
import { Button } from '@progress/kendo-react-buttons';
import { loginAdsClients } from '../../Api/LoginApi';
import { useNavigate } from "react-router-dom";
import { sha256 } from 'crypto-hash';
import BuildIdLogo from "../../Assets/mybuilderid-empowering-trans.png";

export default function LoginForm(props) {
    const navigate = useNavigate();

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [isVisible, setIsVisible] = React.useState(true);

    let handleLogin = async () => {

        try {
            await sha256(password).then(async (hashedPass) => {
                let loginObj = {
                    "Email": email,
                    "Password": hashedPass,
                    "DeviceName": "x",
                    // "Platform": window.navigator.userAgent,
                    "Platform": "x",
                }


                if (hashedPass) {
                    // console.log(loginObj);

                    let loginResult = await loginAdsClients(loginObj);

                    // console.log(loginResult);

                    if (loginResult?.status) {

                        localStorage.setItem("token", loginResult?.data.data.token ?? null);
                        localStorage.setItem("userId", loginResult?.data.data.userId ?? null);
                        localStorage.setItem("firstName", loginResult?.data.data.firstName ?? null);
                        localStorage.setItem("lastName", loginResult?.data.data.lastName ?? null);

                        //Alert for Logging in
                        props.onTriggerAlert('success')
                        props.setAlertMessage("You have successfully Logged in!")

                        navigate("/Campaign-Home")
                    }
                }
            })
        }
        catch (error) {
            console.log(error);

            props.onTriggerAlert('error')
            props.setAlertMessage(error?.response?.data ? error.response.data.errorMessage : error.message)
            // props.setAlertMessage('Wrong Login Credentials!')
        }
    }


    return (
        <React.Fragment className="login">
            <div className="background-shapes">
                <div className="shape-1"></div>
                <div className="shape-2"></div>
                <div className="shape-3"></div>
            </div>
            <Card className="login-container" >
                <div style={{ paddingLeft: "18px" }}>
                    <img width="340px" src={BuildIdLogo} alt="Build ID Logo" />
                </div>

                {/* <CardTitle className='card-title'>
                Login
            </CardTitle> */}

                <CardBody>

                    <Form onSubmit={handleLogin} render={formRenderProps => <FormElement style={{
                        // Width: 350 
                    }}>
                        <fieldset className={'k-form-fieldset'}>

                            {/* Email */}
                            <FieldWrapper>
                                <Field onChange={(e) => setEmail(e.value)} name={"email"} type={"email"} component={EmailInput} label={"Email"} validator={emailValidator} />
                            </FieldWrapper>

                            {/* Password */}
                            <FieldWrapper>
                                <div className='k-form-field-wrap'>
                                    {/* <Field name={'pass'} component={Input} labelClassName={'k-form-label'} label={'Password'} /> */}
                                    {isVisible ?
                                        <span className="k-icon-xxl k-font-icon pass-icon k-i-eye" onClick={() => setIsVisible(!isVisible)}></span> :
                                        <span className="k-icon-xxl k-font-icon pass-icon k-i-eye-slash" onClick={() => setIsVisible(!isVisible)}></span>
                                    }
                                    <Field component={FormInput} onChange={(e) => setPassword(e.value)} label={'Password'} name={'password'} type={isVisible ? 'password' : 'text'} validationMessage={passwordValidationMessage} />

                                </div>
                            </FieldWrapper>

                        </fieldset>
                        <div style={{ display: "flex", flexDirection: "column", gap: "30px", alignItems: "center", }}>
                            <Button
                                themeColor={'primary'}
                                type={'submit'}
                                style={{ marginTop: "25px", width: '100%' }}
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                disabled={!formRenderProps.allowSubmit}
                            >
                                Login
                            </Button>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <div className="forgot-password" onClick={() => props.setActivePage("login-plan-cards")}>
                                    Back
                                </div>
                                <div className="forgot-password" onClick={() => props.setActivePage("forgot-password")}>
                                    Forgot Password?
                                </div>
                            </div>

                        </div>

                        <span className={"k-form-separator"} style={{ margin: "30px" }} />

                        <div className="sign-up">
                            Need an account? <span onClick={() => props.setActivePage("sign-up-hub")}>SIGN UP</span>
                        </div>
                    </FormElement>} />
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

